import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SedsDisplayType } from '../../../shared/types/seds-display.type';
import { SedsThemeColorOptionsType } from '../../../shared/types/seds-theme-color-options.type';

@Component({
    selector: 'seds-alert-basic',
    templateUrl: './seds-alert-basic.component.html',
    standalone: false
})
export class SedsAlertBasicComponent {
  @Input()
  close = false;
  @Input()
  color: SedsThemeColorOptionsType = 'default';
  @Input()
  contentText!: string;
  @Input()
  display: SedsDisplayType | 'inline' | 'block' = 'inline';
  @Input()
  headerTitle!: string;

  @Output()
  hasClosed = new EventEmitter();

  callHasClosed(): void {
    this.hasClosed.emit();
  }
}
